import React from "react";
import styled from "styled-components";
import { media } from "styled-bootstrap-grid";
import { Link } from "react-router-dom";

import downloadSrc from "@assets/download-icon.svg";
import basketSrc from "@assets/basket-icon.svg";
import pdfSrc from '@assets/BW-Stiftung_Jahresbericht_2020_Ansicht.pdf';

const Wrapper = styled(Link)`
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
  color: ${(props) => (props.color ? props.color : "black")};
  background-color: ${(props) =>
    props.backgroundcolor ? props.backgroundcolor : "white"};
  text-decoration: none;
  border: 2px solid black;
  border-radius: 40px;
  padding: 10px 20px;
  margin-right: 1rem;
  flex-shrink: 0;
  margin-bottom: 0.5rem;
  transition: background-color 200ms, color 200ms;
  ${media.sm`
		margin-bottom: 0px;
  `}

  &:hover {
    background-color: ${(props) => props.backgroundcolor == "black" ? "white" : "black"};
    color: ${(props) => (props.color == "black" ? "white" : "black")};

    img {
      filter: invert(1);
    }
  }

  @include respond-to("medium") {
    display: flex;
  }

  p {
    line-height: 1;
		margin-right: ${props => props.src ? '10px' : 'none'};
  }
`;

const Icon = styled.img`
	margin-left: 1rem;
	transition: fliter 200ms;
	-webkit-transition : -webkit-filter 200ms;
	filter: invert(0);
`;

const ButtonGroup = styled.div`
  margin-bottom: 2rem;
`;

const Button = React.forwardRef(({
  to,
  text,
  src,
  backgroundcolor,
  color,
  handleClick,
	className,
	target,
	download

}, ref) => {
  return (
    <Wrapper
			ref={ref}
      className={className}
      to={to}
      backgroundcolor={backgroundcolor}
      color={color}
			target={target}
			download={download}
      onClick={(event) => {
        if (handleClick) {
          handleClick(event);
        }
      }}
    >
      <p>{text}</p>
      {src && <Icon src={src} />}
    </Wrapper>
  );
});

export const Buttons = () => {
  return (
    <ButtonGroup>
			<Button
				to={'#'}
				target="_blank"
				download
				text={`PDF`}
				src={downloadSrc}
				color={`black`}
        backgroundcolor={`white`}
				handleClick={(event) => {
					event.preventDefault()
					window.open(pdfSrc)
				}}
			/>
			<Button
				to={'#'}
				target="_blank"
				text={`Magazinbestellung`}
				src={basketSrc}
				color={`black`}
				backgroundcolor={`white`}
				handleClick={(event) => {
					event.preventDefault()
					window.open('https://www.bwstiftung.de/de/publikation/jahresbericht-2020')
				}}
			/>
    </ButtonGroup>
  );
};

export default Button;
